export const MENU_HEIGHT = 70;
//export const PRIMARY_COLOR = '#a3d158'; //Verde claro
export const PRIMARY_COLOR = '#f0a808'; //Naranja 
//export const PRIMARY_COLOR = '#4A148C'; Morado
export const UPDATEALL_COLOR = '#26794f '; //Verde 
export const DELETEALL_COLOR = '#26794f '; //Verde 

